(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1003],{

/***/ 18491:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tin-tuc/[topic]",
      function () {
        return __webpack_require__(79866);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _topic_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./features/journal/components.tsx + 3 modules
var components = __webpack_require__(41046);
;// CONCATENATED MODULE: ./features/journal/brand-news.tsx




var JournalBrandNewsLayout = function(param) {
    var articles = param.articles;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* JournalShell */.C2, {
        activeKey: "tin-an-thu",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: "Tin An Thư: sự kiện & hoạt động mới nhất",
                description: "Theo d\xf5i sự kiện, hoạt động thương hiệu v\xe0 những th\xf4ng tin mới nhất từ An Thư The Diamond Store."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Breadcrumb */.aG, {
                items: [
                    {
                        label: "Trang chủ",
                        href: "/"
                    },
                    {
                        label: "Tin tức",
                        href: "/tin-tuc/"
                    },
                    {
                        label: "Tin An Thư"
                    }
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                className: "!tw-pt-6 md:!tw-pt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                        children: "G\xd3C AN THƯ"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "tw-font-jr tw-mt-4 tw-mb-4 tw-text-4xl md:tw-text-5xl tw-font-normal",
                        children: "Tin An Thư"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-max-w-[720px] tw-mb-10 tw-text-lg tw-text-jr-mute",
                        children: "Sự kiện, hoạt động thương hiệu v\xe0 những c\xe2u chuyện mới nhất từ An Thư."
                    }),
                    articles.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArticleList */.wD, {
                        items: articles
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-text-jr-mute",
                        children: "Tin tức v\xe0 sự kiện của An Thư đang được cập nhật."
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/journal/press.tsx




var JournalPressLayout = function(param) {
    var articles = param.articles, _unavailable = param.unavailable, unavailable = _unavailable === void 0 ? false : _unavailable;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* JournalShell */.C2, {
        activeKey: "bao-chi",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: "B\xe1o ch\xed & tin tức tổng hợp",
                description: "Tin tức từ c\xe1c cơ quan b\xe1o ch\xed được An Thư t\xf3m lược, k\xe8m li\xean kết nguồn gốc để bạn đọc v\xe0 đối chiếu."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Breadcrumb */.aG, {
                items: [
                    {
                        label: "Trang chủ",
                        href: "/"
                    },
                    {
                        label: "Tin tức & kiến thức",
                        href: "/tin-tuc/"
                    },
                    {
                        label: "B\xe1o ch\xed"
                    }
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                className: "!tw-pt-6 md:!tw-pt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                        children: "G\xd3C AN THƯ"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "tw-font-jr tw-mt-4 tw-mb-4 tw-text-4xl md:tw-text-5xl tw-font-normal",
                        children: "B\xe1o ch\xed"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-max-w-[720px] tw-mb-10 tw-text-lg tw-text-jr-mute",
                        children: "Tin tức từ c\xe1c cơ quan b\xe1o ch\xed, được An Thư t\xf3m lược v\xe0 dẫn nguồn để bạn tiện theo d\xf5i, đối chiếu."
                    }),
                    articles.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArticleList */.wD, {
                        items: articles
                    }) : unavailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-text-jr-mute",
                        role: "status",
                        children: "Chưa thể tải b\xe0i b\xe1o ch\xed. Vui l\xf2ng thử lại sau."
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-text-jr-mute",
                        children: "Chưa c\xf3 b\xe0i viết trong chuy\xean mục B\xe1o ch\xed."
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./features/journal/layout.tsx
var layout = __webpack_require__(77118);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
var _array_with_holes = __webpack_require__(39474);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
var _non_iterable_rest = __webpack_require__(53128);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs





function _toArray(arr) {
  return (0,_array_with_holes/* default */.Z)(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || (0,_non_iterable_rest/* default */.Z)();
}

// EXTERNAL MODULE: ./components/ui/JsonLd/index.tsx
var JsonLd = __webpack_require__(59904);
// EXTERNAL MODULE: ./constants/business.ts
var business = __webpack_require__(56154);
// EXTERNAL MODULE: ./features/journal/promo.ts
var promo = __webpack_require__(30334);
;// CONCATENATED MODULE: ./features/journal/promo-layout.tsx










var SITE = business/* BUSINESS.appUrl */.aL.appUrl;
var APPOINTMENT = "/accounts/appointment/new/";
var articleUrl = function(p) {
    return "/article/".concat(p.article, "/");
};
var Poster = function(param) {
    var src = param.src, alt = param.alt, _className = param.className, className = _className === void 0 ? "" : _className;
    return src ? // eslint-disable-next-line @next/next/no-img-element
    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: src,
        alt: alt,
        width: 1080,
        height: 1350,
        className: "tw-w-full tw-h-auto tw-aspect-[4/5] tw-object-cover ".concat(className)
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-aspect-[4/5] tw-w-full tw-bg-jr-band ".concat(className)
    });
};
var Status = function(param) {
    var children = param.children, light = param.light;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "tw-m-0 tw-flex tw-items-center tw-gap-2 tw-text-[12px] tw-font-medium tw-uppercase tw-tracking-[0.08em] ".concat(light ? "tw-text-[#cfe3de]" : "tw-text-jr-green"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "aria-hidden": "true",
                className: "tw-inline-block tw-h-[6px] tw-w-[6px] ".concat(light ? "tw-bg-[#cfe3de]" : "tw-bg-jr-green")
            }),
            children
        ]
    });
};
var Title = function(param) {
    var text = param.text, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: "tw-font-jr tw-m-0 tw-whitespace-pre-line tw-text-[30px] md:tw-text-[44px] tw-font-normal tw-leading-[1.2] ".concat(className),
        children: text
    });
};
var JournalPromoLayout = function(param) {
    var images = param.images, _news = param.news, news = _news === void 0 ? [] : _news, _promos = param.promos, promos = _promos === void 0 ? promo/* PROMOS */.e : _promos;
    var promoSlugs = new Set(promos.map(function(p) {
        return p.article;
    }));
    var fresh = news.filter(function(a) {
        return !promoSlugs.has(a.slug);
    });
    var ref = (0,react.useState)("all"), filter = ref[0], setFilter = ref[1];
    var live = promos.filter(function(p) {
        return !p.ended;
    });
    var past = promos.filter(function(p) {
        return p.ended;
    });
    var _live = _toArray(live), featured = _live[0], others = _live.slice(1);
    var url = "".concat(SITE, "/tin-tuc/khuyen-mai/");
    var title = "Khuyến m\xe3i An Thư: ưu đ\xe3i trang sức kim cương đang diễn ra";
    var description = "Chương tr\xecnh khuyến m\xe3i, thời gian \xe1p dụng v\xe0 điều kiện tại An Thư The Diamond Store, TP.HCM.";
    var showLive = filter !== "ended";
    var showPast = filter !== "active";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* JournalShell */.C2, {
        activeKey: "khuyen-mai",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: title,
                description: description,
                image: images[featured === null || featured === void 0 ? void 0 : featured.slug] || "".concat(SITE, "/logo-bg.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonLd/* default */.Z, {
                schema: [
                    {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        itemListElement: [
                            {
                                "@type": "ListItem",
                                position: 1,
                                name: "Trang chủ",
                                item: SITE
                            },
                            {
                                "@type": "ListItem",
                                position: 2,
                                name: "Tin tức",
                                item: "".concat(SITE, "/tin-tuc/")
                            },
                            {
                                "@type": "ListItem",
                                position: 3,
                                name: "Khuyến m\xe3i",
                                item: url
                            }, 
                        ]
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "CollectionPage",
                        "@id": "".concat(url, "#page"),
                        url: url,
                        name: title,
                        description: description,
                        inLanguage: "vi",
                        publisher: {
                            "@id": business/* BUSINESS.id */.aL.id
                        },
                        mainEntity: {
                            "@type": "OfferCatalog",
                            name: "Ưu đ\xe3i tại An Thư",
                            itemListElement: live.map(function(p) {
                                return (0,_object_spread/* default */.Z)({
                                    "@type": "Offer",
                                    name: p.short,
                                    description: "".concat(p.desc).concat(p.note ? " ".concat(p.note) : ""),
                                    url: "".concat(SITE).concat(articleUrl(p)),
                                    seller: {
                                        "@id": business/* BUSINESS.id */.aL.id
                                    }
                                }, p.validFrom ? {
                                    validFrom: p.validFrom
                                } : {}, p.validThrough ? {
                                    validThrough: p.validThrough
                                } : {}, images[p.slug] ? {
                                    image: images[p.slug]
                                } : {});
                            })
                        }
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Breadcrumb */.aG, {
                items: [
                    {
                        label: "Trang chủ",
                        href: "/"
                    },
                    {
                        label: "Tin tức",
                        href: "/tin-tuc/"
                    },
                    {
                        label: "Khuyến m\xe3i"
                    }
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-mx-auto tw-w-full tw-max-w-[1296px] tw-px-5 md:tw-px-8 tw-pb-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-grid tw-gap-6 md:tw-grid-cols-[1.3fr_1fr] md:tw-items-end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                                            children: "AN THƯ \xb7 ƯU Đ\xc3I"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                            className: "tw-font-jr tw-mt-4 tw-mb-0 tw-text-[34px] md:tw-text-[52px] lg:tw-text-[56px] tw-font-normal tw-leading-[1.15]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-block",
                                                    children: "Đặc quyền cho"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-block",
                                                    children: "điều xứng đ\xe1ng."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-m-0 tw-text-[17px] tw-text-jr-mute md:tw-max-w-[340px]",
                                    children: "Kh\xe1m ph\xe1 chương tr\xecnh đang \xe1p dụng v\xe0 chọn ưu đ\xe3i ph\xf9 hợp c\xf9ng An Thư."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-mt-8 tw-flex tw-flex-wrap tw-gap-3 tw-border-b tw-border-jr-line tw-pb-8",
                            role: "tablist",
                            "aria-label": "Lọc chương tr\xecnh",
                            children: [
                                [
                                    "all",
                                    "Tất cả chương tr\xecnh"
                                ],
                                [
                                    "active",
                                    "Đang diễn ra"
                                ],
                                [
                                    "ended",
                                    "Đ\xe3 kết th\xfac"
                                ], 
                            ].map(function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], label = _param[1];
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    role: "tab",
                                    "aria-selected": filter === k,
                                    onClick: function() {
                                        return setFilter(k);
                                    },
                                    className: "tw-min-h-[44px] tw-px-6 tw-text-[14px] tw-font-medium ".concat(filter === k ? "tw-bg-jr-green tw-text-white" : "tw-bg-jr-band tw-text-jr-ink hover:tw-bg-jr-top"),
                                    children: label
                                }, k);
                            })
                        })
                    ]
                })
            }),
            showLive && featured && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                className: "!tw-pt-0 !tw-pb-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                        className: "tw-mb-6",
                        children: "CHƯƠNG TR\xccNH NỔI BẬT"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-grid tw-gap-8 md:tw-gap-12 md:tw-grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] tw-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Poster, {
                                src: images[featured.slug],
                                alt: featured.short,
                                className: "md:tw-max-w-[500px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Status, {
                                                children: featured.status
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "tw-m-0 tw-text-[13px] tw-text-jr-mute",
                                                children: featured.period
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        text: featured.title,
                                        className: "tw-mt-6"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-mt-5 tw-mb-0 tw-text-[17px] tw-text-jr-mute tw-leading-relaxed",
                                        children: featured.desc
                                    }),
                                    featured.highlights && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-mt-6 tw-grid tw-grid-cols-2 tw-gap-4",
                                        children: featured.highlights.map(function(h) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tw-bg-jr-band tw-p-5",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "tw-font-jr tw-m-0 tw-text-[26px] tw-text-jr-green",
                                                        children: h.value
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "tw-mt-2 tw-mb-0 tw-text-[13px] tw-text-jr-mute",
                                                        children: h.label
                                                    })
                                                ]
                                            }, h.value);
                                        })
                                    }),
                                    featured.note && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-mt-5 tw-mb-0 tw-text-[14px] tw-text-jr-mute",
                                        children: featured.note
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-mt-7 tw-flex tw-flex-wrap tw-items-center tw-gap-x-8 tw-gap-y-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.A, {
                                                href: articleUrl(featured),
                                                className: "tw-inline-flex tw-min-h-[48px] tw-items-center tw-bg-jr-green tw-px-7 tw-text-[15px] tw-font-medium tw-text-white hover:tw-opacity-90",
                                                children: [
                                                    featured.cta,
                                                    " →"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components.A, {
                                                href: APPOINTMENT,
                                                className: "tw-text-[15px] tw-font-medium tw-text-jr-green hover:tw-underline",
                                                children: "Tư vấn c\xf9ng An Thư →"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showLive && others.map(function(p) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "tw-bg-jr-green tw-text-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-mx-auto tw-w-full tw-max-w-[1296px] tw-px-5 md:tw-px-8 tw-py-10 md:tw-py-14 tw-grid tw-gap-8 md:tw-gap-12 md:tw-grid-cols-[minmax(0,320px)_minmax(0,1fr)] tw-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Poster, {
                                src: images[p.slug],
                                alt: p.short
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Status, {
                                        light: true,
                                        children: p.status
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        text: p.title,
                                        className: "tw-mt-5 tw-text-white"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-mt-5 tw-mb-0 tw-max-w-[560px] tw-text-[17px] tw-leading-relaxed tw-text-[#e3efec]",
                                        children: p.desc
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-mt-5 tw-mb-0 tw-text-[14px] tw-text-[#cfe3de]",
                                        children: p.period
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.A, {
                                        href: articleUrl(p),
                                        className: "tw-mt-7 tw-inline-flex tw-min-h-[48px] tw-items-center tw-bg-jr-band tw-px-7 tw-text-[15px] tw-font-medium tw-text-jr-green hover:tw-opacity-90",
                                        children: [
                                            p.cta,
                                            " →"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }, p.slug);
            }),
            showLive && fresh.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-wrap tw-items-end tw-justify-between tw-gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                                        children: "MỚI NHẤT"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "tw-font-jr tw-mt-3 tw-mb-0 tw-text-[28px] md:tw-text-[40px] tw-font-normal",
                                        children: "Tin khuyến m\xe3i & sự kiện."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-text-[15px] tw-text-jr-mute",
                                children: "B\xe0i mới nhất từ An Thư, cập nhật tự động."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-8 tw-grid tw-gap-x-5 tw-gap-y-10 sm:tw-grid-cols-2 lg:tw-grid-cols-3",
                        children: fresh.map(function(a) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArticleCard */.Tn, {
                                a: a,
                                fit: "poster",
                                showDate: true
                            }, a.id);
                        })
                    })
                ]
            }),
            showPast && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-wrap tw-items-end tw-justify-between tw-gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                                        children: "Đ\xc3 KẾT TH\xdaC"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "tw-font-jr tw-mt-3 tw-mb-0 tw-text-[28px] md:tw-text-[40px] tw-font-normal",
                                        children: "Những m\xf9a ưu đ\xe3i trước."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-text-[15px] tw-text-jr-mute",
                                children: "Th\xf4ng tin lưu trữ để bạn xem lại chương tr\xecnh."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-8 tw-grid tw-gap-4",
                        children: past.map(function(p) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-grid tw-gap-6 md:tw-grid-cols-[140px_1fr_auto] tw-items-center tw-bg-jr-band tw-p-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Poster, {
                                        src: images[p.slug],
                                        alt: p.short,
                                        className: "tw-max-w-[140px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Status, {
                                                children: p.status
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                                text: p.title.replace("\n", " "),
                                                className: "tw-mt-3 !tw-text-[26px] md:!tw-text-[30px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "tw-mt-3 tw-mb-0 tw-text-[15px] tw-text-jr-mute",
                                                children: p.desc
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components.A, {
                                        href: articleUrl(p),
                                        className: "tw-text-[15px] tw-text-jr-mute hover:tw-text-jr-green hover:tw-underline md:tw-self-end",
                                        children: [
                                            p.cta,
                                            " →"
                                        ]
                                    })
                                ]
                            }, p.slug);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
                className: "!tw-pt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-border-t tw-border-jr-line tw-pt-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "tw-font-jr tw-m-0 tw-text-[28px] md:tw-text-[40px] tw-font-normal",
                            children: "Chọn ưu đ\xe3i ph\xf9 hợp với bạn."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-mt-8 tw-grid tw-gap-8 md:tw-grid-cols-3",
                            children: [
                                [
                                    "Xem điều kiện",
                                    "Đọc phạm vi v\xe0 thời gian \xe1p dụng của từng chương tr\xecnh."
                                ],
                                [
                                    "Tư vấn c\xf9ng An Thư",
                                    "Trao đổi về m\xf3n trang sức v\xe0 ưu đ\xe3i ph\xf9 hợp với đơn h\xe0ng."
                                ],
                                [
                                    "Trải nghiệm tại cửa h\xe0ng",
                                    "Xem sản phẩm v\xe0 x\xe1c nhận điều kiện trước khi lựa chọn."
                                ], 
                            ].map(function(param, i) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), t = _param[0], d = _param[1];
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "tw-font-jr tw-m-0 tw-text-[24px] tw-text-jr-gold",
                                            children: String(i + 1).padStart(2, "0")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "tw-mt-3 tw-mb-0 tw-text-[18px] tw-font-medium",
                                            children: t
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "tw-mt-2 tw-mb-0 tw-text-[15px] tw-text-jr-mute",
                                            children: d
                                        })
                                    ]
                                }, t);
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/tin-tuc/[topic].tsx







var JournalTopicPage = function(props) {
    return "brandArticles" in props ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JournalBrandNewsLayout, {
        articles: props.brandArticles
    }) : "pressArticles" in props ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JournalPressLayout, {
        articles: props.pressArticles,
        unavailable: props.pressUnavailable
    }) : "promoImages" in props ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JournalPromoLayout, {
        images: props.promoImages,
        promos: props.promos,
        news: props.news
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* JournalTopicLayout */.S, (0,_object_spread/* default */.Z)({}, props));
};
var __N_SSP = true;
/* harmony default export */ var _topic_ = (JournalTopicPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2031,8276,4904,7118,9774,2888,179], function() { return __webpack_exec__(18491); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);